/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Credential } from './credential';


export interface AuditLog { 
    id?: string;
    credential?: Credential;
    entity_id?: string;
    entity_type?: string;
    type?: string;
    summary?: string;
    creation_timestamp?: string;
}

